export const moveBinderInAdminUi = 'moveBinderInAdminUi';
export const showPackagesAndFeaturesForOrganizationInAdmin =
  'showPackagesAndFeaturesForOrganizationInAdmin';
export const batchOperations = 'batchOperations';
export const Configcat_useSelectOrgPlatform = 'Configcat_useSelectOrgPlatform';
export const Configcat_selectPackageOnOrgCreation =
  'Configcat_selectPackageOnOrgCreation';
export const Configcat_ImproveGlobalWorkflowTemplateList =
  'Configcat_ImproveGlobalWorkflowTemplateList';
export const Configcat_newInspectionTemplate =
  'Configcat_newInspectionTemplate';
export const Configcat_PrefixIdForIssues = 'Configcat_PrefixIdForIssues';
export const removeUserAssignments = 'removeUserAssignments';
